import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { Subscription } from 'rxjs';
import { StocksExchangeCheckoutAction } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';

@Component({
    selector: 'checkout-wrapper-component',
    templateUrl: './checkout-wrapper.component.html',
    styleUrls: [ './checkout-wrapper.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class CheckoutWrapperComponent extends DialogPanelComponentContent implements OnDestroy {

    private disposableSubscriptions: Subscription[] = [];

    public constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        @Inject(DOCUMENT) private document: Document,
        public elementRef: ElementRef,
        private dialogReference: MatDialogRef<CheckoutWrapperComponent>,
        private store: Store<AppState>,
    ) {
        super(elementRef, true);
        this.document.body.classList.add('freeze');
    }

    public ngOnDestroy(): void {
        this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: null });
    }

    public closeDialog() {
        this.document.body.classList.remove('freeze');
        this.close(this.dialogReference, null);
        this.dialogReference = null;
    }

    // public onResize(event) {
    //     window.innerHeight = event.target.innerWidth;
    // }
}
